import axios from 'api/axios'

export interface ActivateSignalsResponse {
	success: boolean
	message: string
}

const activateSignalsForUser = async (
	clientId: string,
	adminId: string
): Promise<ActivateSignalsResponse> => {
	const { data } = await axios.post<ActivateSignalsResponse>(
		`admin/management/activate-signals/${adminId}?clientId=${encodeURIComponent(
			clientId
		)}`
	)
	return data
}

export default activateSignalsForUser
